import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=35196e27&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=35196e27&prod&scoped=true&lang=css"
import style1 from "./Chat.vue?vue&type=style&index=1&id=35196e27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35196e27",
  null
  
)

export default component.exports